import Table from './TableComponent'
import TableContainer from './TableContainer';

export default TableContainer(Table)
